export const getInterestingStocksState = state => state.historyList;
